import { DASHBOARD, DOCUMENTS } from 'common/endpoints';
import BaseServiceRetryWrapper from './baseRetry';

class FilesService extends BaseServiceRetryWrapper {
  getPreSignedUrl = (mdId: string, fileType: string, autoClassify: boolean = false) =>
    this.get(DOCUMENTS.getPreSignedUrl(mdId, fileType, autoClassify));

  getCompanyDocuments = (companyId: string) => this.get(DOCUMENTS.getCompanyDocuments(companyId));

  createFileRepresentation = (documentsId: string, data: unknown) =>
    this.post(DOCUMENTS.createFileRepresentation(documentsId), data);

  downloadDocument = (fileId: string, firmId: string) => this.get(DOCUMENTS.downloadDocument(fileId, firmId));

  downloadDocumentContent = (fileId: string, firmId: string) =>
    this.get(DOCUMENTS.downloadDocumentContent(fileId, firmId));

  deleteDocument = (documentsId: string, fileId: string) =>
    this.delete(DOCUMENTS.updateOrDeleteDocument(documentsId, fileId));

  updateDocument = (documentsId: string, fileId: string, data: unknown) =>
    this.put(DOCUMENTS.updateOrDeleteDocument(documentsId, fileId), data);

  getFeaturesObjects = (mdId: string) => this.get(DOCUMENTS.getFeaturesObjects(mdId));

  addDocumentReference = (mdId: string, fileId: string, data: unknown) =>
    this.post(DOCUMENTS.addDocumentReference(mdId, fileId), data);

  getReferencesByMeasurementDateId = (mdId: string) => this.get(DOCUMENTS.getReferencesByMeasurementDateId(mdId));

  createSubFolder = (docsId: string, data: unknown) => this.post(DOCUMENTS.createSubFolder(docsId), data);

  updateSubFolder = (docsId: string, folderId: string, data: unknown) =>
    this.put(DOCUMENTS.updateSubFolder(docsId, folderId), data);

  deleteFolder = (docsId: string, folderId: string) => this.delete(DOCUMENTS.updateSubFolder(docsId, folderId));

  addFilesToFolder = (documentsId: string, data: unknown) => this.post(DOCUMENTS.addFilesToFolder(documentsId), data);

  validateDocumentRequestToken = (requestId: string, token: string) =>
    this.get(DOCUMENTS.validateDocumentRequestToken(requestId, token));

  contactRequestingUserFromPortal = (requestId: string, token: string) =>
    this.post(DOCUMENTS.contactRequestingUserFromPortal(requestId, token));

  generatePostSignedUrlViaHMACToken = (requestId: string, token: string, mdId: string, type: string) =>
    this.get(DOCUMENTS.generatePostSignedUrlViaHMACToken(requestId, token, mdId, type));

  updateRequestedFileUploadStatus = (requestId: string, token: string, data: unknown) =>
    this.post(DOCUMENTS.updateRequestedFileUploadStatus(requestId, token), data);

  markRequestedFileFulfillmentPortal = (
    requestId: string,
    token: string,
    requestedFileId: number | string,
    data: { fulfillment_status: string; fulfillment_note?: string | null }
  ) => this.patch(DOCUMENTS.markRequestedFileFulfillmentPortal(requestId, token, requestedFileId), data);

  markRequestedFileFulfillment = (
    requestedFileId: number | string,
    data: { fulfillment_status: string; fulfillment_note?: string | null }
  ) => this.patch(DOCUMENTS.markRequestedFileFulfillment(requestedFileId), data);

  sendDocumentRequest = (data: unknown) => this.post(DOCUMENTS.sendDocumentRequest, data);

  updateTaskStatusFromPortal = (requestId: string, token: string, taskId: string, data: unknown) =>
    this.patch(DOCUMENTS.updateTaskStatusFromPortal(requestId, token, taskId), data);

  hasDocuments = (companyId: string, measurementDateId: string) =>
    this.get(DOCUMENTS.hasDocuments(companyId, measurementDateId));

  downloadValuationReport = (cmdId: number) => this.get(DASHBOARD.downloadValuationReport(cmdId));

  getDocumentById = (documentId: string) => this.get(DOCUMENTS.getDocumentById(documentId));

  convertPdfTablesToXlsx = (fileId: string, companyId: string, data: { page_numbers: number[] }) =>
    this.post(DOCUMENTS.convertPdfTablesToXlsx(fileId, companyId), data);

  // Classification methods
  approveClassification = (documentReferenceId: string) =>
    this.post(DOCUMENTS.approveClassification(documentReferenceId), {});

  declineClassification = (documentReferenceId: string) =>
    this.post(DOCUMENTS.declineClassification(documentReferenceId), {});
}

export default FilesService;
